module.exports = __webpack_public_path__ + "static/media/planes_icono.9e1748ea.svg";